import gql from "graphql-tag";

export const customerQuery = gql`
  query customer($customerId: ID!) {
    customer(id: $customerId) {
      id
      name
      isActive
      storage {
        id
      }
      accessGroup {
        id
      }
      companies {
        id
        name
      }
      dealers {
        id
        firstName
        lastName
        detail {
          ... on Dealer {
            status
          }
        }
        phone
        email
        roles {
          name
        }
      }
    }
  }
`;
